import { PropTypes } from 'prop-types';
import React from 'react';

import { useFooter } from '../../graphql/hooks';
import SvgImage from '../Global/SvgImage';
import Link from '../Link';
import Logo from '../Logo/Logo';
import Newsletter from '../Newsletter';

const Footer = ({ data }) => {
  if (!data) data = useFooter();
  const {
    copyright,
    emailPlaceholder,
    emailTitle,
    pageLinks,
    socialMediaLinks,
  } = data;

  return (
    <div className="footer">
      <div className="footer__content">
        <div className="footer__content--top">
          <div className="logo-wrapper">
            <Logo />
          </div>
          <div className="newsletter">
            <Newsletter
              full
              inverse
              placeholder={emailPlaceholder}
              title={emailTitle}
            />
          </div>
        </div>
        <div className="footer__content--bottom">
          <div className="footer__content--bottom__page-link">
            {pageLinks.map((link) => (
              <Link key={link.title} to={link.url}>
                {link.title}
              </Link>
            ))}
          </div>
          <div className="icons">
            {socialMediaLinks.map(({ icon: { file, svg }, title, url }) => (
              <a key={url} href={url} rel="noreferrer" target="_blank">
                <SvgImage alt={title} file={file} svg={svg} />
              </a>
            ))}
          </div>
        </div>
        <div className="footer__content--copyright">{copyright}</div>
      </div>
    </div>
  );
};

Footer.propTypes = {
  data: PropTypes.object,
};

export default Footer;
